/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiBaseService } from '../api-base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getFaq } from '../fn/faq/get-faq';
import { GetFaq$Params } from '../fn/faq/get-faq';
import { GetFaqResult } from '../models/get-faq-result';

@Injectable({ providedIn: 'root' })
export class ApiFaqService extends ApiBaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getFaq()` */
  static readonly GetFaqPath = '/Faq';

  /**
   * get-faq.
   *
   * Get FAQ<br>Get FAQ relative to the culture
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFaq()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFaq$Response(params?: GetFaq$Params, context?: HttpContext): Observable<StrictHttpResponse<GetFaqResult>> {
    return getFaq(this.http, this.rootUrl, params, context);
  }

  /**
   * get-faq.
   *
   * Get FAQ<br>Get FAQ relative to the culture
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFaq$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFaq(params?: GetFaq$Params, context?: HttpContext): Observable<GetFaqResult> {
    return this.getFaq$Response(params, context).pipe(map((r: StrictHttpResponse<GetFaqResult>): GetFaqResult => r.body));
  }
}
